// src/utils/cache.js

export function loadFromCache(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveToCache(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

export function getTimestamp(key) {
  const v = localStorage.getItem(key);
  return v ? parseInt(v, 10) : 0;
}

export function setTimestamp(key, ts = Date.now()) {
  localStorage.setItem(key, String(ts));
}

const SCHEDULES = [
  { hour: 10, minute: 0 },
  { hour: 18, minute: 0 },
];

function getScheduledTimestamp(baseDate, { hour, minute }) {
  return new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    hour,
    minute,
    0,
    0
  ).getTime();
}

// 가장 최근의 스케줄(10:00, 18:00) 이후에 생성된 캐시인지 확인
export function isFresh(cacheTimestamp) {
  if (!cacheTimestamp) return false;

  const now = new Date();

  let lastUpdateTime = 0;

  for (const schedule of SCHEDULES) {
    const scheduledTime = getScheduledTimestamp(now, schedule);
    if (now.getTime() >= scheduledTime) {
      lastUpdateTime = Math.max(lastUpdateTime, scheduledTime);
    }
  }

  if (!lastUpdateTime) {
    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const lastSchedule = SCHEDULES[SCHEDULES.length - 1];
    lastUpdateTime = getScheduledTimestamp(yesterday, lastSchedule);
  }

  return cacheTimestamp > lastUpdateTime;
}
